import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { Button } from "reactstrap";
import { Modal, } from "react-bootstrap";
import { sendData, defaultHeaders, } from "../../services/auth";

import { useSelector } from "react-redux";
import { uriList } from "../../helpers/config";
import { width, } from "../../helpers";
import { Aguarde, } from '../../helpers/general'
import { confirmSwal, swalError } from "../../helpers/swal";

const InsertContagensItens = (props) => {
  const [contagem, setContagem] = useState(props.data || props.contagem)
  const [contagemItens, setContagemItens] = useState([])
  const [quantidade, setQuantidade] = useState(1)
  const [produto, setProduto] = useState("")
  const [gravando, setGravando] = useState(false)
  const _login = useSelector((state) => state.login);
  const [loaded, setLoaded] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const [excluindo, setExcluindo] = useState(false)
  const [exibirTodos, setExibirTodos] = useState(true)
  const [loadingItens, setLoadingItens] = useState(false)
  const [localizacao, setLocalizacao] = useState(null)
  const [nomeProduto, setNomeProduto] = useState(null)
  const [warningProduto, setWarningProduto] = useState(false)

  const primeiroCampo = useRef(null);
  const segundoCampo = useRef(null);
  const terceiroCampo = useRef(null);

  // Função para manipular o evento onKeyDown
  const handleKeyDown = (e, refCampo) => {
    if (e.keyCode === 13) { // 13 é o código da tecla Enter
      refCampo.current.focus();
    }
  };

  useEffect(() => {
    getData()
  }, [])

  const handleFocus = (campoRef) => {
    if (campoRef?.current)
      campoRef.current.select();
  };

  async function handleDeleteItem(item) {
    async function callback(e) {
      if (!e) return
      console.log("InsertContagensItens.handleDeleteItem(callback): ", e)
      setExcluindo(true)
      await axios({
        url: uriList("delContagemItem"),
        method: 'POST',
        headers: defaultHeaders(),
        data: { ...item }
      })
        .then(res => {
          setExcluindo(false)
          console.log("Registro excluido: ", res)
          getData()
          primeiroCampo.current.focus()
        })
        .catch(error => {
          setExcluindo(false)
          console.log("Erro ao excluir registro: ")
          console.log(error)
        })
    }

    if (!excluindo && !gravando)
      confirmSwal({ callback, title: "Confirma a exclusão do item?" });
  }

  async function getData() {
    console.log("InsertContagensItens.getData: ", { contagem, _login })
    setLoaded(false)
    // getProdutos()

    await getContagemItens()

    setLoaded(true)
  }

  async function getContagemItens() {
    console.log("InsertContagensItens.getContagemItens: ", { filtrarLocalizacao: localizacao })
    setLoadingItens(true)
    await sendData({
      uri: uriList("contagemItens"), content: {
        contagemid: contagem?.CONTAGEMID, empresaid: _login?.empresaid,
        usuarioid: exibirTodos ? null : _login?.usuarioid
      }
    })
      .then((res) => {
        const _res = res?.data || res
        console.log("InsertContagensItens.contagemItens: ", _res);
        if (_res.status && parseInt(_res.status) > 200) throw new Error();
        setContagemItens(_res)
      })
      .catch((e) => {
        console.log(e);
        alert("Erro ao obter Localizacoes.\n" + e.message);
      });

    setLoadingItens(false)
  }

  async function getItem() {
    let result = false
    if (produto && contagem?.CONTAGEMID)
      await sendData({ uri: uriList("contagemItens"), content: { referencia: produto, contagemid: contagem?.CONTAGEMID } })
        .then((res) => {
          console.log("InsertContagensItens.getItem: ", res.data);
          if (res.status && parseInt(res.status) > 200) throw new Error();

          result = res?.data?.[0]
        })
        .catch((e) => {
          console.log(e);
          alert("Erro ao obter item.\n" + e.message);
        });

    return result
  }

  async function fetchEstoqueProduto(referencia) {
    if (!referencia) return null
    try {
      const res = await sendData({ uri: uriList("estoqueProduto"), content: { referencia } })
      const _res = res?.data || res
      console.log("InsertContagensItens.fetchEstoqueProduto: ", _res);
      if (_res.status && parseInt(_res.status) > 200) throw new Error();
      return _res ?? null
    } catch (e) {
      console.log(e);
      alert("Erro ao obter item.\n" + e.message);
      return null
    }
  }

  async function getProduto() {
    console.log("InsertContagensItens.getProduto: ", { produto, nomeProduto });
    if (produto && !nomeProduto) {
      setWarningProduto(false)
      setNomeProduto(null)
      const data = await fetchEstoqueProduto(produto)
      console.log(data)
      if (data) {
        console.log("InsertContagensItens.getProduto(Nome): ", data?.NOME);
        setNomeProduto(data.NOME)
        setLocalizacao(data.LOCALIZACAO)
        handleFocus(segundoCampo)
        setWarningProduto(!data.NOME)
      } else {
        setWarningProduto(true)
      }
    }

    return true
  }

  function focus() {
    primeiroCampo.current.focus()
  }

  async function handlePost(e, isClose) {
    if (e)
      e.preventDefault()

    let nomeParaGravar = nomeProduto
    let locParaGravar = localizacao

    if (produto && !nomeParaGravar) {
      const data = await fetchEstoqueProduto(produto)
      if (!data?.NOME) {
        setWarningProduto(true)
        swalError({ callback: focus, title: "Produto não encontrado ou inválido." })
        return false
      }
      nomeParaGravar = data.NOME
      setNomeProduto(data.NOME)
      if (!locParaGravar && data.LOCALIZACAO != null && String(data.LOCALIZACAO).trim() !== "") {
        locParaGravar = data.LOCALIZACAO
        setLocalizacao(data.LOCALIZACAO)
      }
    }

  
    if (!produto || !locParaGravar || !quantidade) {
      swalError({ callback: focus, title: "Informe todos os dados!" })
      return false
    }

    //-- Mesma sessão: soma quantidade ao registro já listado (sem aviso)
    const refNorm = String(produto || "").trim()
    const itemJaNaLista = contagemItens?.find(
      (item) => String(item.REFERENCIA || "").trim() === refNorm
    )
    if (itemJaNaLista) {
      let rowId = itemJaNaLista.ID ?? itemJaNaLista.id
      if (!rowId) {
        const fromDb = await getItem()
        rowId = fromDb?.ID ?? fromDb?.id
      }
      if (!rowId) {
        swalError({ callback: focus, title: "Não foi possível identificar o registro. Atualize a lista e tente novamente." })
        return false
      }

      const qtdAtual = parseFloat(itemJaNaLista.QUANTIDADE ?? 0) || 0
      const qtdInformada = parseFloat(quantidade ?? 0) || 0
      const quantidadeTotal = qtdAtual + qtdInformada

      setGravando(true)
      axios({
        url: uriList("updateContagemItemQuantidade"),
        method: 'POST',
        headers: defaultHeaders(),
        data: {
          id: rowId,
          quantidade: quantidadeTotal,
          localizacao: locParaGravar,
          empresaid: _login?.empresaid,
          usuarioid: _login?.usuarioid,
        },
      })
        .then(() => {
          setGravando(false)
          limparDados()
          if (isClose)
            handleClose()
          else
            getData()
          primeiroCampo.current.focus()
        })
        .catch((error) => {
          setGravando(false)
          console.log(error)
          swalError({ title: "Erro ao atualizar quantidade!", text: error?.message || error })
        })
      return false
    }

    let itemExiste = await getItem()
    //-- Item já no banco mas não aparece na lista filtrada (ex.: outro usuário)
    if (itemExiste) {
      swalError({ callback: focus, title: "Item já incluído(outro)!", text: itemExiste?.USUARIOI + " - " + itemExiste?.REFERENCIA + itemExiste?.PRODUTO + " - " + itemExiste?.QUANTIDADE })
      return false
    }

    setGravando(true)
    const _data = {
      produto: produto,
      localizacao: locParaGravar,
      quantidade,
      contagemid: contagem?.CONTAGEMID,
      empresaid: _login?.empresaid,
      usuarioid: _login?.usuarioid,
      id: null,
      REFERENCIA: produto,
      PRODUTO: nomeParaGravar,
      QUANTIDADE: quantidade,
      LOCALIZACAO: locParaGravar,
    }

    setContagemItens([...contagemItens, _data])

    axios({
      url: uriList("addContagemItem"),
      method: 'POST',
      headers: defaultHeaders(),
      data: _data
    })
      .then(res => {
        setGravando(false)
        console.log("Registro gravado: ", res)
        limparDados()
        if (isClose)
          handleClose()
        else
          getData()

        primeiroCampo.current.focus()
      })
      .catch(error => {
        setGravando(false)
        console.log("Erro ao gravar registro: ")
        console.log(error)
        swalError({ title: "Erro ao gravar registro!", text: error?.message || error })
        limparDados()
      })

    limparDados()
  }

  function limparDados(e) {
    if (e && e.preventDefault)
      e.preventDefault()

    primeiroCampo.current.focus();
    setProduto("")
    setQuantidade(1)
    setLocalizacao("")
    setNomeProduto("")
    setWarningProduto(false)
  }

  function handleClose() {
    if (props.onCloseEv)
      props.onCloseEv()
  }

  const isMobile = width() === "mobile"

  return (
    <>
      <Modal
        size={isMobile ? "sm" : "lg"}
        show={true}
        onHide={handleClose}
        centered
        animation={false}
        backdrop="static"
        dialogClassName="modal-contagem-itens"
      >
        <Modal.Header closeButton >
          <Modal.Title>
            <span>Contagem de Itens</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={`maxWidth750${isMobile ? " px-2" : ""}`} style={{ overflowX: "hidden", maxWidth: "100%", boxSizing: "border-box" }}>
          <div style={{ maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box" }}>
            {deleting && <Aguarde legenda={"Aguarde, excluindo registro..."} />}
            {/* {gravando && <Aguarde legenda={"Aguarde, gravando registro..."} />} */}
            <form className={`form g-2 border needs-validation ${isMobile ? "p-1 contagem-itens-form-mobile" : "p-2"} ${' was-validated '}`} noValidade disabled={loadingItens}
              id="form-upload-documentos"
              style={{ maxWidth: "100%", boxSizing: "border-box" }}
            >
              {!props.empresa &&
                <div className="row g-1">
                </div>}
              {isMobile ? (
                <div className="row g-1 mx-0">
                  <div className="col-12 px-0 mb-1">
                    <input
                      className="form-control form-control-sm contagem-itens-input-produto"
                      id="produto"
                      ref={primeiroCampo}
                      style={{ borderColor: warningProduto ? "red" : undefined }}
                      placeholder="Código do produto"
                      aria-label="Código do produto"
                      onKeyDown={(e) => handleKeyDown(e, segundoCampo)}
                      autoFocus={true}
                      onFocus={() => handleFocus(primeiroCampo)}
                      maxLength={12}
                      onBlur={getProduto}
                      type="text"
                      value={produto}
                      onChange={(e) => {
                        setProduto(e?.target?.value?.toUpperCase())
                        setNomeProduto(null)
                      }}
                      required
                    />
                  </div>
                  {(nomeProduto || warningProduto) && (
                    <div className="col-12 px-0 mb-1">
                      <div className="contagem-itens-nome-produto text-truncate" title={nomeProduto || ""}>
                        {nomeProduto || ""}{produto && warningProduto && " — Produto não encontrado"}
                      </div>
                    </div>
                  )}
                  <div className="col-12 d-flex align-items-end w-100 px-0 contagem-itens-linha-compacta">
                    <div className="flex-grow-1 contagem-itens-loc" style={{ minWidth: 0 }}>
                      <span className="contagem-itens-mini-label">Local</span>
                      <input
                        ref={segundoCampo}
                        onFocus={() => handleFocus(segundoCampo)}
                        className="form-control form-control-sm"
                        id="localizacao"
                        type="text"
                        value={localizacao || ""}
                        onKeyDown={(e) => handleKeyDown(e, terceiroCampo)}
                        onChange={(item) => setLocalizacao(item?.currentTarget?.value?.toUpperCase())}
                        required
                      />
                    </div>
                    <div className="flex-shrink-0 contagem-itens-qtd">
                      <span className="contagem-itens-mini-label">Qtd</span>
                      <input
                        ref={terceiroCampo}
                        onFocus={() => handleFocus(terceiroCampo)}
                        className="form-control form-control-sm text-center contagem-itens-input-qtd"
                        id="number"
                        type="number"
                        value={quantidade}
                        min="1"
                        max="999999"
                        step="1"
                        onKeyDown={(e) => handleKeyDown(e, primeiroCampo)}
                        onChange={(item) => setQuantidade(item.currentTarget.value)}
                        required
                      />
                    </div>
                    <div className="flex-shrink-0 d-flex align-items-end contagem-itens-wrap-gravar">
                      <Button
                        color="success"
                        className="btn btn-success contagem-itens-btn-gravar"
                        title="Gravar registro de contagem"
                        disabled={!loaded || loadingItens || gravando}
                        onClick={e => { handlePost(e, false) }}
                      >
                        Gravar
                      </Button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='row g-1 d-flex flex-wrap'>
                  <div className="form-group col-md-4">
                    <label className="m-0 font-90">Produto</label>
                    <input className="form-control" id="produto" ref={primeiroCampo}
                      style={{ borderColor: warningProduto ? "red" : "", }}
                      onKeyDown={(e) => handleKeyDown(e, segundoCampo)} autoFocus={true}
                      onFocus={() => handleFocus(primeiroCampo)}
                      maxLength={12} onBlur={getProduto}
                      type="text" value={produto} onChange={(e) => {
                        setProduto(e?.target?.value?.toUpperCase())
                        setNomeProduto(null)
                      }} required />
                  </div>

                  <div className="form-group col-md-3">
                    <label className="m-0 font-90">Localização</label>
                    <input ref={segundoCampo}
                      onFocus={() => handleFocus(segundoCampo)}
                      className="form-control" id="localizacao" type="text" value={localizacao || ""}
                      onKeyDown={(e) => handleKeyDown(e, terceiroCampo)}
                      onChange={(item) => setLocalizacao(item?.currentTarget?.value?.toUpperCase())} required />
                  </div>

                  <div className="form-group col-md-3">
                    <label className="m-0 font-90">Quantidade</label>
                    <input ref={terceiroCampo}
                      onFocus={() => handleFocus(terceiroCampo)}
                      className="form-control" id="number" type="number" value={quantidade} min="1" max="999999" step="1"
                      onKeyDown={(e) => handleKeyDown(e, primeiroCampo)}
                      onChange={(item) => setQuantidade(item.currentTarget.value)} required />
                  </div>
                  <div className="form-group col-md-2 ">
                    <Button color="success"
                      className="btn btn-success btn-block mt-3"
                      title="Gravar registro de contagem"
                      disabled={!loaded || loadingItens || gravando}
                      onClick={e => { handlePost(e, false) }} style={{ marginRight: "5px" }}>
                      Gravar
                    </Button>
                  </div>
                </div>
              )}
              {!isMobile && <div className='row g-1 d-flex col-md-12'>
                {nomeProduto && <label style={{ fontStyle: "italic" }} className="m-0 font-90">{`${(nomeProduto ? nomeProduto : '')}`} {produto && warningProduto && "<Produto não encontrado>"}</label>}
              </div>}
              <div className={`form-group col-md-12 px-0 ${isMobile ? "mt-1" : ""}`} style={{ marginTop: isMobile ? undefined : "10px" }}>
                <div
                  className="row mx-0"
                  style={{
                    overflowY: "auto",
                    overflowX: "hidden",
                    maxHeight: isMobile ? "min(42vh, 200px)" : "400px",
                    maxWidth: "100%",
                  }}
                >
                  {isMobile ? (
                    <div className="w-100 contagem-itens-lista-mobile" style={{ opacity: excluindo || gravando ? 0.5 : 1 }}>
                      <div className="contagem-itens-lista-titulo">Itens lançados</div>
                      {loadingItens ? (
                        <div className="small text-muted py-2">Carregando...</div>
                      ) : !contagemItens?.length ? (
                        <div className="small text-muted py-2">Nenhum item lançado.</div>
                      ) : null}
                      {!loadingItens && contagemItens?.map((contagemItem, index) => {
                        const rowKey = contagemItem?.ID ?? contagemItem?.id ?? index
                        return (
                          <div
                            key={rowKey}
                            className="contagem-itens-item-mobile border-bottom"
                            style={{ cursor: "pointer", wordBreak: "break-word" }}
                            onClick={() => handleDeleteItem(contagemItem)}
                          >
                            <div className="contagem-itens-item-linha1">{contagemItem?.REFERENCIA}{" — "}{contagemItem?.PRODUTO}</div>
                            <div className="d-flex justify-content-between align-items-center contagem-itens-item-linha2">
                              <span className="text-nowrap flex-shrink-0 contagem-itens-item-qtd">Qtd <strong>{contagemItem?.QUANTIDADE}</strong></span>
                              <span className="text-muted text-right contagem-itens-item-loc" style={{ minWidth: 0, wordBreak: "break-word" }} title={contagemItem?.LOCALIZACAO}>
                                {contagemItem?.LOCALIZACAO}
                              </span>
                              {!excluindo && (
                                <i
                                  title="Excluir ítem da contagem"
                                  className="fa fa-trash flex-shrink-0 ml-2"
                                  style={{ fontSize: "12px", color: "red" }}
                                  onClick={(e) => { e.stopPropagation(); handleDeleteItem(contagemItem); }}
                                  role="button"
                                  tabIndex={0}
                                  onKeyDown={(e) => { if (e.key === "Enter") { e.stopPropagation(); handleDeleteItem(contagemItem); } }}
                                />
                              )}
                            </div>
                          </div>
                        )
                      })}
                      <div className="contagem-itens-lista-rodape">
                        {contagemItens?.length ?? 0} registro(s)
                      </div>
                    </div>
                  ) : (
                    <table className="table table-striped table-hover mb-1 rounded w-100" style={{ opacity: excluindo || gravando ? "50%" : "", tableLayout: "fixed" }}>
                      <thead className="thead-dark">
                        <tr>
                          <th scope="col" style={{ width: "46%" }}>Produto</th>
                          <th scope="col" style={{ width: "12%" }}>Qtdade</th>
                          <th scope="col">Localizacao</th>
                          <th scope="col" style={{ width: "5%" }}>#</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!contagemItens && <tr><td colSpan={4}>Carregando...</td></tr>}
                        {contagemItens?.map((contagemItem, index) => {
                          const rowKey = contagemItem?.ID ?? contagemItem?.id ?? index
                          return (
                            <tr key={rowKey} style={{ cursor: "pointer" }} onClick={() => handleDeleteItem(contagemItem)}>
                              <td style={{ wordBreak: "break-word" }}>{contagemItem?.REFERENCIA + ' - ' + contagemItem?.PRODUTO}</td>
                              <td>{contagemItem?.QUANTIDADE}</td>
                              <td style={{ wordBreak: "break-word" }}>{contagemItem?.LOCALIZACAO}</td>
                              {!excluindo &&
                                <td
                                  style={{ width: "5%" }}
                                  disabled={excluindo || gravando}
                                  onClick={() => handleDeleteItem(contagemItem)}>{<i title="Excluir ítem da contagem" style={{ fontSize: "12px", color: "red" }} className="fa fa-trash" />}</td>}
                            </tr>
                          )
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan={4} className="text-left">
                            Qtd Registros: {contagemItens && contagemItens.length}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  )}
                </div>
              </div>
            </form>
          </div>
        </Modal.Body >
        <Modal.Footer className={isMobile ? "px-2 py-2 contagem-itens-footer-mobile" : ""}>
          <div className={`mr-0 w-100 d-flex justify-content-end flex-wrap ${isMobile ? "contagem-itens-footer-btns" : ""}`} style={{ gap: isMobile ? "0.5rem" : "0.35rem" }}>
            <Button color="warning"
              title="Limpar dados digitados"
              onClick={limparDados}
              className={isMobile ? "btn-sm" : ""}
              style={{ marginLeft: isMobile ? 0 : "5px", minWidth: isMobile ? "4.5rem" : undefined }}>
              Limpar
            </Button>
            <Button color="secondary"
              className={isMobile ? "btn-sm ml-0" : "ml-1"}
              title="Fechar tela de contagem"
              style={{ marginLeft: isMobile ? 0 : "5px", minWidth: isMobile ? "4.5rem" : undefined }}
              onClick={handleClose}>
              Fechar
            </Button>
          </div>
        </Modal.Footer>
      </Modal >
    </>
  );
}

export default InsertContagensItens;